var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "line-chart" }, [
    _c("canvas", { attrs: { id: _vm.chartId } }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "legend", attrs: { id: _vm.legendId } },
      _vm._l(_vm.linechartdata.datasets, function(dataset) {
        return _c("div", { key: dataset.label, staticClass: "legend-child" })
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }